export default () => ({
  item: {},
  items: [],
  promotionProducts: [],
  promotionProductsPagination: {}
})
